/**
 * 容器组件发送要提交的数据
 */
export default {
    created () {
        // 有组件要提交数据的监听
        this.handleGiveMeSubmitData && this.$eventHub.$on(this.$events.GIVE_ME_SUBMIT_DATA, this.handleGiveMeSubmitData)
    },
    methods: {
        /**
         * 发送要提交的数据
         */
        sendSubmitData (data) {
            // 发送需要提交的数据
            this.$eventHub.$emit(this.$events.HERE_YOU_SUBMIT_DATA, data)
        },
        /**
         * 发送要查询的数据
         */
        sendSearchData (data) {
            this.$eventHub.$emit(this.$events.SEARCH_DATA, data)
        },
        /**
        * 发送批量操作选中的数据
        */
        sendBatchData (data) {
            this.$eventHub.$emit(this.$events.BATCH_HANDLE_DATA, data)
        },
        /**
         * 发送提交数据行为的改变
         */
        sendSubmitMethodData (data) {
            this.$eventHub.$emit(this.$events.SUBMIT_METHOD_UPDATE, data)
        }
    },
    destroyed () {
        // 销毁事件的监听
        this.handleGiveMeSubmitData && this.$eventHub.$off(this.$events.GIVE_ME_SUBMIT_DATA, this.handleGiveMeSubmitData)
    }
}



// WEBPACK FOOTER //
// ./src/utils/compSend.mixin.js